import { render, staticRenderFns } from "./task_messaging_user.vue?vue&type=template&id=d8ad8fec&scoped=true"
import script from "./task_messaging_user.vue?vue&type=script&lang=js"
export * from "./task_messaging_user.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8ad8fec",
  null
  
)

export default component.exports